import React from "react";
import { AuthService } from "./auth.service";
import { AuthContext } from "./AuthContext";
import { AuthContextProviderProps } from "./AuthContextProviderProps.interface";

export const AuthContextProvider = (props: AuthContextProviderProps) => {
  const { children } = props;

  return (
    <AuthContext.Provider value={AuthService}>{children}</AuthContext.Provider>
  );
};

export const AuthConsumer = AuthContext.Consumer;
